import type { ReplayPlugin } from "@slot/client-engine";
import type { AudioService } from "../ports/AudioService";

/**
 * The audio's view of a feature: the feature state (music bed) and the enter / exit cues. List it
 * AFTER the feature-finished plugin: the exit cue follows the finished panel (the audio log is part
 * of the e2e contract).
 */
export function createFeatureAudioPlugin(deps: { audioService: AudioService }): ReplayPlugin {
  return {
    name: "feature-audio",
    observer: {
      onFeatureState: async (event) => {
        const featureState = event.eventContent.featureState;
        if (!featureState) return;
        if (featureState.featurePhase === "enter") {
          deps.audioService.control.setFeatureState(featureState.featureIdentifier);
          deps.audioService.presentation.emit({ id: "feature.enter", meta: { feature: featureState.featureIdentifier } });
        }
        if (featureState.featurePhase === "exit") {
          deps.audioService.control.setFeatureState(null);
          deps.audioService.presentation.emit({ id: "feature.exit" });
        }
      },
    },
  };
}
